import { FEATURES } from "../../config/site";
import { Icon } from "../brand/Icon";
import { SectionHeading } from "../common/SectionHeading";

const FeatureCard = ({ f, wide }) => (
  <article
    data-testid={`feature-card-${f.id}`}
    className={`card-premium group p-7 lg:p-9 ${wide ? "md:col-span-2" : ""}`}
  >
    <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-[#07080C] text-[#FF5500] transition-transform duration-300 group-hover:-translate-y-0.5">
      <Icon name={f.icon} className="h-5 w-5" />
    </div>
    <h3 className="mt-8 font-display text-xl font-semibold text-slate-50 sm:text-2xl">{f.title}</h3>
    <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">{f.body}</p>
  </article>
);

export const FeaturesSection = () => (
  <section id="features" className="section-pad border-t border-white/5 bg-[#0B0D14]">
    <div className="container-x">
      <SectionHeading label="Features" title="Built around the moment someone needs you." />
      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {FEATURES.map((f, i) => <FeatureCard key={f.id} f={f} wide={i === 0 || i === 5} />)}
      </div>
    </div>
  </section>
);
